import * as jsonata from 'jsonata';

export class JSONAtaObject<T = any> {
  private _value: T;

  constructor(data: T) {
    this.data = data;
  }

  public static chain(data: any): JSONAtaObject {
    return new JSONAtaObject(data);
  }

  public async transform(jsonataConfig: string): Promise<JSONAtaObject> {
    const expression = jsonata(jsonataConfig);
    const result = await expression.evaluate(this.data);
    this.data = result;
    return this;
  }

  private set data(value: T) {
    this._value = value;
  }

  private get data() {
    return this._value;
  }

  public get value() {
    return this.data;
  }
}
